const timerMaxSeconds = 900;
let currentTimerValue = 0;
let timerReference: number | null = null;

const timerTarget = document.getElementById("timer-container");
const timerTextTarget = document.getElementById("timer-text-container");

const update = () => {
  currentTimerValue++;

  if (currentTimerValue > timerMaxSeconds) {
    stopTimer();
  }

  if (timerTarget) {
    const timerValue = timerMaxSeconds - currentTimerValue;
    const minutes = Math.floor(timerValue / 60);
    const seconds = timerValue % 60;
    timerTarget.innerText = `${minutes}:${String(seconds).padStart(2, "0")}`;
  }
};

export const startTimer = (text: string) => {
  currentTimerValue = 0;

  if (timerTextTarget) {
    timerTextTarget.innerText = text;
  }

  if (timerReference != null) {
    return;
  }

  // Trigger a start first to make sure it's updated
  update();

  timerReference = window.setInterval(update, 1000);
};

export const stopTimer = () => {
  if (!timerReference) {
    return;
  }

  clearInterval(timerReference);
  currentTimerValue = 0;
};
